import React from 'react';

import { ROLES } from '@permissions';

import type { AuthContextProperties } from './AuthProvider.types';

export const AuthProviderContext = React.createContext<AuthContextProperties>({
  id: '',
  email: '',
  first_name: '',
  last_name: '',
  full_name: '',
  role: ROLES.unset,
  phone_number: '',
  phone_number_country: '',
  settings: {
    date_format: '',
    number_format: 'ru-RU',
    locales: 'ru',
    theme: 'light',
  },
  email_verified: false,
  phone_verified: false,
  is_verified: false,
  data_complete: false,
  is_authenticated: false,
  user_carrot_quest_hash: '',
});
